export default {
  title: 'Prescribing physician information',
  titleDescription: 'Complete the following information to continue',
  nameLabel: 'Name and Lastname',
  specialtyLabel: 'Specialty',
  license: 'License',
  countryLabel: 'Country code'
}